import { render, staticRenderFns } from "./DownloadCardGrid.vue?vue&type=template&id=ad3ed316&scoped=true&"
import script from "./DownloadCardGrid.vue?vue&type=script&lang=js&"
export * from "./DownloadCardGrid.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCardGrid.vue?vue&type=style&index=0&id=ad3ed316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3ed316",
  null
  
)

export default component.exports